module.exports = __webpack_public_path__ + "media/images/shared/icon-weibo-8b01479e9ac3809c2bb26e38ccb9f45d.png";